import { comments } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="relative py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">剧迷热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自真实观众的使用反馈，听听追剧伙伴们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((item) => (
            <article
              key={item.id}
              className="bg-background-100 border border-background-200/50 rounded-xl p-5 md:p-6 hover:border-background-300/50 transition-all duration-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{item.name}</div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-secondary-400"></i>
                    ))}
                    {Array.from({ length: 5 - item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-line text-xs text-foreground-400"></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}